import FadeModal from './FadeModal';

export default FadeModal;
